var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m2.887 17.586-1.274-1.272L11.979 5.927l10.407 10.386-1.272 1.274-9.134-9.114-9.093 9.113Z",
    fill: "#303030"
  })));
};
export { SvgChevronUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMi44ODY4NSAxNy41ODU2TDEuNjEyNzkgMTYuMzE0MUwxMS45NzkyIDUuOTI3MDlMMjIuMzg1NiAxNi4zMTI5TDIxLjExNDEgMTcuNTg2OUwxMS45ODAzIDguNDczMzlMMi44ODY4NSAxNy41ODU2WiIgZmlsbD0iIzMwMzAzMCIvPgo8L3N2Zz4K";